import React, { useEffect } from 'react';
import { getCityFromPath } from "../app/auth";

const ErrorView: React.FC = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const cityName = getCityFromPath();
      const newPath = cityName ? `/${cityName}/app/dashboard` : '/app/dashboard';
      window.history.replaceState(null, '', newPath);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white p-4">
      <div className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-lg w-full text-center">
        <h1 className="text-3xl font-bold mb-4">Fehler</h1>
        <p className="mb-4">Die Webanwendung funktioniert nicht korrekt. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>
      </div>
    </div>
  );
};

export default ErrorView;
